var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settlement-detail"},[_c('detail-head',{attrs:{"data":_vm.headData}}),_c('detail-list',{attrs:{"data":_vm.settlementData,"status":_vm.status},on:{"calculate":_vm.handleCalculate,"refresh":_vm.fetch}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }